import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Show {
    constructor() {
        this.initTaxatie();
        this.propertySlider();
        this.initSoldSlider();
    }

    initTaxatie() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            },
        });
    }

    propertySlider() {
        if (document.querySelector('#properties')) {
            const slider = new Swiper('#properties .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {

                    // when window width is >= 640px
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },

                },
                navigation: {
                    nextEl: '#properties .swiper-button-next',
                    prevEl: '#properties .swiper-button-prev',
                },
            });
            slider.on('slideChangeTransitionStart resize', function() {
                // console.log(slider.slides, slider.realIndex)
                slider.slides.forEach(function(i, index) {
                    if (index < slider.realIndex) {
                        i.classList.add('swiper-slide-prev')
                    }
                })
            })
        }
    }

    initSoldSlider() {
        if (document.querySelector('#soldProperties')) {
            new Swiper('#soldProperties .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 2500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                },
            });
        }
    }
}
